import { Data, Params } from '@angular/router';

export function buildHybridContainerState(
    navState: string,
    paramConverter?: (p: Params, currentStateData?: Data) => Params,
    hybridStateCondition?: (d: Data) => boolean
) {
    return {
        navState,
        onContainer: true,
        paramConverter,
        hybridStateCondition
    };
}
